import {Component, Input, OnInit, EventEmitter} from '@angular/core';
import {Property} from '../../../shared/property/property.model';
import {AppUtils} from '../../../shared/app-utils';
import {AppConfigService} from '../../../config/app-config.service';
import {TranslatorService} from '../../../shared/translator.service';
import {TranslateService} from '../../../shared/translate.service';
import {Title} from '@angular/platform-browser';
import {TabConfigStructure} from '../../../config/tab-config-structure';
import {ObjectDetailTitle} from '../../search-list/results/result-item/object-detail-title.model';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-work',
  templateUrl: './work.component.html',
  styleUrls: ['./work.component.css']
})
export class WorkComponent implements OnInit {

  @Input() materializationsLength: number = 0;

  @Input() realizationsLength: number = 0;

  @Input() onlineVersionAvailable: boolean = false;

  properties: Property[];

  title: Property;

  work: any;

  titleWrapper = new ObjectDetailTitle({authors: [], title: null, extras: []});

  addToFavLabel = this.translateService.translate('ResultItem.addToFavourites');
  imgPath: string;

  constructor(private appConfig: AppConfigService,
              private translatorService: TranslatorService,
              private translateService: TranslateService,
              private titleService: Title) {
  }

  @Input('work')
  set _work(work: any) {
    this.work = work;
    this.init();
  }

  ngOnInit() {
    this.init();
    if (this.title) {
      this.titleService.setTitle('Omnis - ' + this.title.value);
    }
    this.imgPath = 'apiCoverUrl/api/works/' + this.work.id + '/cover';
  }

  getConfig(): TabConfigStructure[] {
    return this.appConfig.workConfig.bookConfig;
  }

  getWorkLink(): string {
    return '/work/' + this.work['work_host_item_work_uuid'][0];
  }

  private init() {
    this.properties = AppUtils.mapObjectToProperties(this.work);
    this.title = this.translatorService.find(this.properties, 'work_title_pref');
    this.work.type = 'work'; //add type
    this.titleWrapper = AppUtils.createTitleWrapper(this.work, false);
  }

}
